import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    component: () => import('@/views/Home.vue')
  },
  // 普莱柯购物狂欢节
  {
    path: '/register',
    component: () => import('@/views/register.vue')
  },
  // 隐私声明
  {
    path: '/agreement',
    component: () => import('@/views/agreement.vue')
  },
  // 隐私声明
  {
    path: '/agreement-privacy',
    component: () => import('@/views/agreement-privacy.vue')
  },
  // 好兽药用户发布须知
  {
    path: '/notice',
    component: () => import('@/views/notice.vue')
  },
  // 产品详情
  {
    path: '/shopdetails',
    component: () => import('@/views/shopdetails.vue')
  },
  // 产品特点、产品优势、应用案例
  {
    path: '/shopcase',
    component: () => import('@/views/shopcase.vue')
  },
  // 商品详情
  {
    path: '/detail',
    component: () => import('@/views/detail.vue')
  },
  // 普莱柯专场
  {
    path: '/special',
    component: () => import('@/views/special.vue')
  },
  // 销售统计-统计报告
  {
    path: '/SalesIndex',
    name: 'SalesIndex',
    component: () => import('@/views/salesStatistics/index')
  },
  // 销售统计-查看范围
  {
    path: '/SalesRange',
    component: () => import('@/views/salesStatistics/range')
  },
  // 种猪报告
  {
    path: '/breedingPig',
    component: () => import('@/views/healthy/breedingPig')
  },
  // 商品猪阶段报告
  {
    path: '/commodityPigStage',
    component: () => import('@/views/healthy/commodityPigStage')
  },
  // 商品猪周期报告
  {
    path: '/commodityPigCycle',
    component: () => import('@/views/healthy/commodityPigCycle')
  },
  // 好兽药订单详情
  {
    path: '/orderdetail',
    component: () => import('@/views/orderdetail')
  },
  // 好兽药订单详情
  {
    path: '/orderdetail2',
    component: () => import('@/views/orderdetail2')
  },
  // 莱客云个人统计 PersonalStatistics
  {
    path:'/personalStatistics',
    name:'PersonalStatistics',
    component: () => import('@/views/personalStatistics/personalStatistics')
  },
  // 好兽药直播
  {
    path: '/liveBroadcast',
    name: 'liveBroadcast',
    component: () => import('@/views/video/liveBroadcast')
  },
  // 好兽药直播测试
  {
    path: '/liveBroadcast1',
    name: 'liveBroadcast1',
    component: () => import('@/views/video/liveBroadcast1')
  },
  // 好兽药聊天室登录
  {
    path: '/chatlogin',
    name: 'chatlogin',
    component: () => import('@/views/chatroom/chatlogin')
  },
  // 好兽药聊天室
  {
    path: '/chat',
    name: 'chat',
    component: () => import('@/views/chatroom/chat')
  },
  // 好兽药聊天室
  {
    path: '/chat1',
    name: 'chat1',
    component: () => import('@/views/chatroom/chat1')
  },
  // 组方详情
  {
    path: '/prescriptiondetail',
    name: 'prescriptiondetail',
    component: () => import('@/views/prescriptiondetail.vue')
  },
  // 测试
  {
    path: '/authentication',
    name: 'authentication',
    component: () => import('@/views/authentication.vue')
  },
  // 专家详情
  {
    path: '/guide',
    name: 'guide',
    component: () => import('@/views/guide.vue')
  },
  // 运营活动
  {
    path: '/activities',
    name: 'activities',
    component: () => import('@/views/activities.vue')
  },
  // 商铺详情
  {
    path: '/shopmall',
    name: 'shopmall',
    component: () => import('@/views/shopmall.vue')
  },
  // 中科名兽医宣传页 好兽药链接地址
  {
    path: '/propagandahsy',
    name: 'propagandahsy',
    component: () => import('@/views/propagandahsy.vue')
  },
  // 专家注册协议
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test.vue')
  },
]

// const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes
// })

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export default router
